import api from './api'

const contactService = {
  // Submit contact query (Public)
  submitQuery: async (queryData) => {
    const response = await api.post('/contact/submit', queryData)
    return response.data
  },

  // Authenticated user: Get my enquiries
  getMyQueries: async (params = {}) => {
    const response = await api.get('/contact/my', { params })
    return response.data
  },

  // Admin: Get all queries
  getAllQueries: async (params = {}) => {
    const response = await api.get('/contact', { params })
    return response.data
  },

  // Admin: Get query statistics
  getQueryStats: async () => {
    const response = await api.get('/contact/stats')
    return response.data
  },

  // Admin: Get query by ID
  getQueryById: async (id) => {
    const response = await api.get(`/contact/${id}`)
    return response.data
  },

  // Admin: Reply to query
  replyToQuery: async (id, replyData) => {
    const response = await api.post(`/contact/${id}/reply`, replyData)
    return response.data
  },

  // Admin: Update query status
  updateQueryStatus: async (id, status) => {
    const response = await api.patch(`/contact/${id}/status`, { status })
    return response.data
  },

  // Admin: Delete query
  deleteQuery: async (id) => {
    const response = await api.delete(`/contact/${id}`)
    return response.data
  },
}

export default contactService
